<template>
  <div class="addEditBlogWrap">
    <el-dialog :title="title" :visible.sync="$parent.dialogVisible" width="50%">
      <div class="formContent">
        <el-form
          label-width="80px"
          :model="formInline"
          ref="ruleForm"
          class="demo-form-inline"
          :rules="rules"
        >
          <el-form-item prop="titleTxt" label="博客标题">
            <el-input v-model="formInline.titleTxt"></el-input>
          </el-form-item>
          <el-form-item prop="txtContent" label="博客内容">
            <div id="desc"></div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBtn">取 消</el-button>
        <el-button
          @click="submitForm('ruleForm')"
          type="primary"
          :loading="$store.state.user.loadingState"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import E from "wangeditor";
export default {
  props: ["title"],
  data() {
    return {
      //编辑器对象
      editor: null,
      formInline: {
        titleTxt: "",
        txtContent: "",
      },
      rules: {
        titleTxt: [
          { required: true, message: "标题不能为空" },
          { whitespace: true, message: "标题不能为空" },
        ],
        txtContent: [],
      },
    };
  },
  methods: {
    createEditor() {
      this.editor = new E("#desc");
      this.editor.config.uploadImgShowBase64 = true;
      this.editor.create();
      this.editor.txt.html(this.formInline.txtContent);
    },
    closeBtn() {
      this.$parent.dialogVisible = false;
    },
    submitForm(formName) {
      // console.log(this.editor.txt);
      this.formInline.txtContent = this.editor.txt.html();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.commit("SET_LOADING", true);
          this.$emit("getAddBolg", this.formInline);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    if (this.$parent.title == "编辑") {
      this.formInline.titleTxt = this.$parent.detailsData.title;
      this.formInline.txtContent = this.$parent.detailsData.details;
    }
    this.$nextTick(() => {
      this.createEditor();
    });
  },
};
</script>

<style lang="scss" scoped>
.addEditBlogWrap {
  .formContent {
    width: 90%;
    height: 550px;
    overflow-y: auto;
  }
}
</style>